export default __webpack_public_path__ + "static/PermanentMobile-67235ac4b162a8a4fb04a3c110518b30.png";